const tables = document.querySelectorAll(
	'.block-table-wrapper.is-style-horizontal-stripes .block-table'
) as NodeListOf<HTMLElement>;

const classes = ['is-style-pro', 'is-style-con'];

if (tables) {
	tables.forEach((table) => {
		let accordion = `<div class="block-accordion">`;

		const rows = table.querySelectorAll('tbody tr') as NodeListOf<HTMLElement>;
		const lastRowIndex = rows.length - 1;
		const cols: string[] = [];

		const topRow = rows[0];
		const topLeftCell = topRow.querySelector(
			'th:first-child .table-cell-inner, td:first-child .table-cell-inner'
		) as HTMLElement;

		const topLeftCellEmpty = !topLeftCell || '' === topLeftCell.textContent?.trim();

		rows.forEach((row, rowIndex) => {
			const cells = row.querySelectorAll('th, td') as NodeListOf<HTMLElement>;
			if (cells) {
				const firstCell = cells[0];
				const firstCellHTML = firstCell.querySelector('.table-cell-inner');

				const firstCellContent = firstCellHTML?.innerHTML.replace(/style="[^"]*"/g, '');

				cells.forEach((cell, cellIndex) => {
					const classList = [...cell.classList];
					const cellClasses = classList.filter((item) => classes.includes(item));
					const cellClassesString = cellClasses.join(' ');
					const cellHTML = cell.querySelector('.table-cell-inner') as HTMLElement;
					const cellContent = cellHTML?.innerHTML.replace(/style="[^"]*"/g, '');

					if (!cols[cellIndex]) {
						cols[cellIndex] = ``;
					}
					if (0 === rowIndex) {
						cols[cellIndex] = cols[cellIndex] + `<div class="block-accordion__item">`;

						const expanded = topLeftCellEmpty && 1 === cellIndex ? 'true' : 'false';

						cols[cellIndex] =
							cols[cellIndex] +
							`<button class="block-accordion__button" aria-controls="block-accordion-${cellIndex}" aria-expanded="${expanded}">${cellContent}</button>`;

						cols[cellIndex] =
							cols[cellIndex] +
							`<div class="block-accordion__content" id="block-accordion-${cellIndex}" aria-expanded="${expanded}">`;
					} else if (topLeftCellEmpty) {
						cols[cellIndex] =
							cols[cellIndex] +
							`<div class="block-accordion__cell">` +
							firstCellContent +
							`<div class="${cellClassesString}">` +
							cellContent +
							`</div></div>`;
					} else {
						cols[cellIndex] =
							cols[cellIndex] +
							`<div class="block-accordion__cell"><div class="${cellClassesString}">` +
							cellContent +
							`</div></div>`;
					}

					if (lastRowIndex === rowIndex) {
						cols[cellIndex] = cols[cellIndex] + `</div></div>`;
					}
				});
			}
		});

		if (topLeftCellEmpty) {
			cols.shift();
		}

		cols.forEach((col) => {
			accordion = accordion + col;
		});

		accordion = accordion + `</div>`;

		// Remove existing accordion if one exists
		const existingAccordion = table.nextElementSibling;
		if (existingAccordion?.classList.contains('block-accordion')) {
			existingAccordion.remove();
		}

		table.insertAdjacentHTML('afterend', accordion);
	});
}
